/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getDocByStatusADM(Status, ModelId, ClientId, token) {
  const apiUrl = `${API_BASE_URL}/admin/document/list/bystatus`;

  const requestBody = {
    Status,
    ModelId,
  };

  if (ClientId) {
    requestBody.ClientId = ClientId;
  }

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(requestBody),
  });
  console.log("getDocByStatusADM HERE:"); // Log the entire response for debugging
  return data.message.list;
}